// src/config.ts
// Fallback to "" (relative URL, resolved against domain root) if the build
// did not have VITE_API_BASE_URL injected. Without this fallback, a missing
// env var becomes the literal string "undefined" in the axios baseURL, which
// the browser then resolves as a RELATIVE path against the current page's
// directory (e.g. /lms/login -> /lms/undefined/api/...) instead of the
// domain root. See frontend/.env.uat for the uatil.intellendtech.com values.
const rawApiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string) || "";

export const API_BASE_URL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
	? ""
	: rawApiBaseUrl;

export const API_BASE_URL_ABSOLUTE = rawApiBaseUrl;

export const DIGIO_DIGILOCKER_BASE_URL = import.meta.env.VITE_DIGIO_DIGILOCKER_BASE_URL as string;
export const DIGIO_ENVIRONMENT = import.meta.env.VITE_DIGIO_ENVIRONMENT as 'sandbox' | 'production';
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;

/**
 * Payment gateway mode.
 *   'sim'                — internal simulation gateway (PASS/FAIL buttons)
 *   'juspay_sandbox'     — Juspay sandbox API
 *   'juspay_production'  — Juspay production API
 *
 * Set via VITE_PAYMENT_GATEWAY_MODE in the environment's .env file.
 * Defaults to 'sim' so UAT environments are unaffected unless explicitly switched.
 */
export const PAYMENT_GATEWAY_MODE = (
    import.meta.env.VITE_PAYMENT_GATEWAY_MODE ?? 'sim'
) as 'sim' | 'juspay_sandbox' | 'juspay_production';
